export const bookingData = [
  {
    id: 1,
    title: "What is online booking?",
    content: `Online booking is a convenient way of booking your trips over the internet. Using GIGM online services you can request a particular seat and pay online with your credit or debit card using our secure server.`,
  },
  {
    id: 3,
    title: "How do I change details of my booking after paying online?",
    content: `Please contact our Online booking support on 09087342709`,
  },
  {
    id: 4,
    title: "Where can I find my/the booking reference number?",
    content: `It is displayed on the notification sent to the email you registered with after your booking has been made. It is an alpha-numeric code.`,
  },
  {
    id: 5,
    title: "How do I know if my ticket has been booked and paid for?",
    content: `Once you have confirmed your trip, personal and payment details, deductions will be made from your account and a summary of this information will be displayed along with your booking reference. SMS / email notifications stating it as a SUCCESSFUL TRANSACTION will also be sent to the email address/mobile number provided by you during the booking process. The booking reference indicates that your reservation has been confirmed.`,
  },
  {
    id: 6,
    title: "What happens when I experience problems while booking online?",
    content: `Kindly contact our online booking support on 09087342709, any of our customer care lines as listed on the GIGM website for assistance or send email to contact@gigm.com`,
  },
  {
    id: 7,
    title: "What should I do if I lose my booking reference number?",
    content: `Kindly contact our online booking support on 09087342709 or any of our customer care lines and emails: contact@gigm.com as listed on the GIGM website for assistance.`,
  },
];

export const ticketData = [
  {
    id: 1,
    title: "If I book online, how do I get my ticket?",
    content: `If you make a reservation online, you will receive an email communicating details of your trip. Kindly present a print out of this email or show the reference code for your boarding ticket to be issued to you at the terminal.`,
  },
];

export const paymentData = [
  {
    id: 1,
    title:
      "Can I check availability and fares without actually purchasing a ticket?",
    content: `Yes, you do not need to pay or provide your card details to check availability and fares. We only require your payment details if you choose to complete a booking.`,
  },
  {
    id: 2,
    title:
      "What payment methods are available when booking online and at your terminal?",
    content: `MasterCard, Visa, Verve cards, Gtb USSD, Bank Transfer are acceptable means of payment on our online platform and POS at the terminals. We are working towards adding more payment options to our online platform.`,
  },
  {
    id: 3,
    title: "Can I cancel my booking after payment and do you do refunds?",
    content: `We have a no refund policy. All payments are final. However, the tickets are valid for a thirty day period from date of purchase.`,
  },
  {
    id: 4,
    title:
      "Can I pay to the Captain or Field Executives for my excess luggage?",
    content: `All payments are to be made over the counter to the Ticketer after declaring your luggage size. Usually an extra seat(s) is/are paid for. This must be receipted as evidence of payment.`,
  },
];

export const busesData = [
  {
    id: 1,
    title: "What happens if I lose an item in the bus or terminal premises?",
    content: `It is your responsibility to monitor your items when travelling with our buses and through our facilities. However, we will assist in trying to locate the items left behind in the bus cabin or Terminal premises if we are contacted immediately.`,
  },
  {
    id: 2,
    title: "Why is your seat number 2 unavailable?",
    content: `The seat no 2 in our vehicles are generally reserved for Luggage. It is only at the event of it not being utilized for luggage that it is then sold to a guest with preference given to anyone who may have indicated interest for the seat initially.`,
  },
  {
    id: 3,
    title:
      "What happens if I miss my bus after purchasing ticket via your online platform or walk in pre-booking prior to trip?",
    content: `Guests check-in closes 30 minutes before departure time. Failure to meet this time for any reason will attract an administrative of one thousand naira (₦1000) for rescheduling. Please note that rescheduled tickets are subject to schedule, bus type and seat availability. The reschedule fee applies, pre or post departure day and time.`,
  },
  {
    id: 4,
    title: "What baggage allowance am I entitled to?",
    content: `Guests are entitled to one medium sized luggage. Should luggage exceed the acceptable limit, you may be required to pay for an additional seat(s) to comfortably accommodate the baggage or send the excess luggage via our sister company God Is Good Logistics (GIGL). This is critical to maintain the service and safety and standards of GIGM.`,
  },
];
